<template>
  <textarea v-model="internal_value" @input="evt => $emit('input', evt.target.value)"></textarea>
</template>

<script>
import autosize from 'autosize'

export default {
  name: 'AutoResizeTextarea',
  props: ['value'],
  data () {
    return {
      internal_value: this.value
    }
  },
  watch: {
    value (newVal) {
      console.log('new value for textarea', newVal)
      this.internal_value = newVal
    }
  },
  mounted () {
    autosize(this.$el)
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AutoResizeTextarea.vue